import { useRef } from 'react';

/** A finger must travel this far (px), mostly sideways, to count. */
const SWIPE_THRESHOLD = 50;

/**
 * Touch handlers for a left / right swipe. Mostly-vertical movement is left
 * alone, so the page under the element still scrolls. A tap does not trip
 * it - the browser's own click still follows a touch that did not travel.
 */
export function useHorizontalSwipe({
  onLeft,
  onRight,
}: {
  onLeft: () => void;
  onRight: () => void;
}) {
  const start = useRef<{ x: number; y: number } | null>(null);
  return {
    onTouchStart: (e: React.TouchEvent) => {
      const t = e.touches[0];
      start.current = t ? { x: t.clientX, y: t.clientY } : null;
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const from = start.current;
      const t = e.changedTouches[0];
      start.current = null;
      if (!from || !t) return;
      const dx = t.clientX - from.x;
      const dy = t.clientY - from.y;
      if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
      if (dx < 0) onLeft();
      else onRight();
    },
  };
}
